<template>
    <!-- #region use with /taxaddress page -->
    
    <div v-if="isTaxAddress">
        <div class="relative w-full lg:w-554px bg-white text-a-brown-502314  text-14 lg:text-16 mb-4 p-3 lg:p-4 rounded-10 lg:rounded-12 flex flex-col">
            <img class="absolute right-3 lg:right-4" @click="onEditAddress()" src="@/assets/icon/ic-edit-brown.svg" />
            <div class="mb-2 text-14 lg:text-16 break-words pr-6">{{address.taxName}}</div>
            <div class="mb-2 text-14 lg:text-16 text-a-brown-9f8273">{{lbl.tax.taxpayer_id}} : <span class="text-a-brown-502314">{{address.taxId}}</span></div>
            <div class="mb-2 text-14 lg:text-16 text-a-brown-9f8273">{{lbl.tax.mobile_no}} : <span class="text-a-brown-502314">{{FilterPhoneFormat(address.contactNumber)}}</span></div>
            <div class="mb-4 break-words text-14 lg:text-16">
                {{address.taxDetail}}<span v-if="address.taxSubDistrictName">,&nbsp;</span>
                {{address.taxSubDistrictName}},&nbsp;
                {{address.taxDistrictName}},&nbsp;
                {{address.taxProvinceName}},&nbsp;
                {{address.taxZipcode}}
            </div>

            <div class="flex">
                <img class="ml-0 my-auto w-5 h-5" v-show="address.isSelect" @click="setDefaultTaxAddress()" src="@/assets/icon/ic-checkbox-brown.svg" />
                <div class="ml-0 my-auto w-5 h-5 rounded-5 border border-a-brown-d7c7b8 bg-white" @click="setDefaultTaxAddress()" v-show="!address.isSelect"></div>
                <div class="ml-2 my-auto text-14 lg:text-16 text-a-brown-502314">{{lbl.tax.default_address}}</div>
                <button class="flex ml-6" @click="onDeleteAddress()">
                    <img class="ml-0 my-auto"  src="@/assets/icon/ic-bin-red.svg" />
                    <div class="ml-2 my-auto text-14 lg:text-16 text-a-red-d62300">{{lbl.tax.delete_address}}</div>
                </button>
            </div>
        </div>
    </div>
    <!-- #region use with /taxaddress page -->

    <div v-else class="flex pb-3">
        <img class="ml-0 mr-2 my-auto" v-if="address.isSelect" @click="onSelectAddress()" src="@/assets/icon/ic-checkbox-red.svg" />
        <div class="ml-0 mr-2 my-auto w-5 h-5 rounded-5 border border-a-brown-d7c7b8 bg-white" v-else @click="onSelectAddress()"></div>
        <div class="text-14 lg:text-16 text-a-brown-502314 ml-0 mr-auto my-auto address">{{address.taxName}}, Tax ID {{address.taxId}}</div>
        <img class="ml-auto mr-0 my-auto pl-2" @click="onEditAddress()" src="@/assets/icon/ic-edit-brown.svg" />
        <img class="ml-2 mr-0 my-auto pl-2"  @click="onDeleteAddress()" src="@/assets/icon/ic-bin-red.svg" />
    </div>
</template>
<script>
import LocaleMixin from "@/mixin/LocaleMixin.js";
/**
 * @event onDeleteSuccess
 */
export default {
    name: "TaxAddressItem",
    emits:['onSelectAddress', 'setDefaultTaxAddress', 'onDeleteAddress', 'onEditAddress'],
    mixins: [LocaleMixin],
    props: {
        address: Object,
    },
    data: function() {
        return {
            isTaxAddress: false
        };
    },
    created: function() {
        if (this.$route.path == '/taxaddress') {
            this.isTaxAddress = true;
        }
    },
    methods: {
        onSelectAddress: function() {
            //this.$emit('onSelectAddress', this.address);
            this.$emit('onSelectAddress');
        },
        setDefaultTaxAddress: function(){
            this.$emit('setDefaultTaxAddress', this.address);
        },
        onDeleteAddress: function() {
            this.$emit('onDeleteAddress', this.address);
        },
        onEditAddress: function() {
            this.$emit('onEditAddress', this.address);
        },
    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/base/text.scss";
    .address {
        width: calc(100% - 90px);
        @extend %ellipsis-1;
    }
</style>
